import React from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { JurisdictionDetailProvider } from './context/JurisdictionDetailProvider'
import { JurisdictionDetailMain } from './components/JurisdictionDetailMain'

export const JurisdictionDetail = () => {
  const jurisdictionIdParam = useParams<{ jurisdictionId: string }>()
    .jurisdictionId
  const parsedJurisdictionId = jurisdictionIdParam
    ? Number(jurisdictionIdParam)
    : undefined
  const selectedJurisdictionId = Number.isNaN(parsedJurisdictionId)
    ? undefined
    : parsedJurisdictionId

  if (typeof selectedJurisdictionId === 'undefined') {
    return <Navigate to="/not-found" />
  }

  return (
    <JurisdictionDetailProvider jurisdictionId={selectedJurisdictionId}>
      <JurisdictionDetailMain />
    </JurisdictionDetailProvider>
  )
}
